// extracted by mini-css-extract-plugin
module.exports = {"productImage":"index__productImage___29J7r","tag":"index__tag___nbQm7"};